(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-trust-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const footnotes = Array.from(document.querySelectorAll('.trust-banner__footnote'));
    if (!footnotes.length) return;

    const closeAll = (except = null) => {
      footnotes.forEach((footnote) => {
        if (footnote !== except && footnote.open) footnote.open = false;
      });
    };

    footnotes.forEach((footnote) => {
      const trigger = footnote.querySelector('.trust-banner__footnote-trigger');
      if (!trigger) return;

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const nextState = !footnote.open;
        closeAll(footnote);
        footnote.open = nextState;
      });
    });

    document.addEventListener('click', (event) => {
      const active = footnotes.find((footnote) => footnote.open);
      if (!active) return;
      if (active.contains(event.target)) return;
      closeAll();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
